import { OnboardResult, RoleType, User } from "@/models/user.model";
import apiClient from "./apiClient";
import { PaymentInfo } from "@/models/payment-info.model";
import {
  CreateEmploymentInfo,
  EmploymentInfo,
} from "@/models/employment-info.model";
import { CreateStaffInfo, StaffInfo } from "@/models/staff-info.model";
import { getUTCDate } from "@/utils/date-format";
import { CreateLeaveBalanceOnboard } from "@/models/leave-balances.model";

export const register = async (
  fullName: string,
  email: string,
  role: RoleType,
  password: string
): Promise<User> => {
  const res = await apiClient.post("/auth/register", {
    fullName,
    email,
    role,
    password,
  });
  const data: User = res.data as User;
  return data;
};

export const getAllUsers = async (args: {
  search?: string;
  role?: RoleType;
}): Promise<User[]> => {
  const { search, role } = args;
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  
  if (role) params.append("role", role);

  const res = await apiClient.get("/users", { params });
  const data: User[] = res.data as User[];
  return data;
};

export const getUser = async (userId: number): Promise<User> => {
  try {
    const res = await apiClient.get(`/users/${userId}`);
    const data: User = res.data as User;
    return data;
  } catch (error) {
    console.log(error);
    return {} as User;
  }
};

export const updateUser = async (
  id: number,
  fullName: string,
  email: string
): Promise<User> => {
  try {
    const res = await apiClient.patch(`/users/${id}`, {
      fullName,
      email,
    });
    const data: User = res.data as User;
    return data;
  } catch (error) {
    console.log(error);
    return {} as User;
  }
};

export const deleteUser = async (id: number): Promise<boolean> => {
  try {
    const res = await apiClient.delete(`/users/${id}`);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const onboardUser = async (
  userId: number,
  args: {
    paymentInfo: PaymentInfo;
    employmentInfo: CreateEmploymentInfo;
    staffInfo: CreateStaffInfo;
    leaveBalances: CreateLeaveBalanceOnboard[];
  }
): Promise<OnboardResult> => {
  args.staffInfo.dateOfBirth = getUTCDate(args.staffInfo.dateOfBirth);
  args.employmentInfo.hireDate = getUTCDate(args.employmentInfo.hireDate);
  args.employmentInfo.confirmedDate = args.employmentInfo.confirmedDate
    ? getUTCDate(args.employmentInfo.confirmedDate)
    : undefined;

  const res = await apiClient.post(`/users/${userId}/onboard`, {
    ...args,
  });
  const data: OnboardResult = res.data as OnboardResult;
  return data;
};
